<article class="brand-list-datatable">
  <table mat-table [dataSource]="brands()" class="mat-table-container">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element" class="mat-table-container__brand">
        <div>
          <img
            [ngSrc]="element.logoUrl || '/assets/images/broken-image.svg'"
            [alt]="element.name"
            [height]="40"
            [width]="40"
            class="mat-table-container__brand-logo"
          />

          <section>
            <span>
              {{ element.name }}
            </span>
            <span class="mat-table-container__brand__created-at">
              Créé le : {{ element.createdAt | date: 'dd/MM/YYYY' }}
            </span>
          </section>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="group">
      <th mat-header-cell *matHeaderCellDef>Groupe</th>
      <td mat-cell *matCellDef="let element">
        {{ element.group?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="sector">
      <th mat-header-cell *matHeaderCellDef>Secteur</th>
      <td mat-cell *matCellDef="let element">
        {{ element.sector?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="subSector">
      <th mat-header-cell *matHeaderCellDef>Sous-secteur</th>
      <td mat-cell *matCellDef="let element">
        {{ element.subSector?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="mat-table-container__actions-header"
      >
        Actions
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="mat-table-container__actions"
      >
        <button
          type="button"
          (click)="onRowClick(element)"
          matTooltip="Modifier"
          aria-label="Modifier"
        >
          <img [lazyLoad]="'assets/icons/eye.svg'" alt="View" />
        </button>
        <button (click)="onEdit(element)" type="button" matTooltip="Modifier">
          <img [lazyLoad]="'assets/icons/pen-to-square.svg'" alt="edit" />
        </button>
        <button
          (click)="onDelete(element)"
          type="button"
          matTooltip="Supprimer"
        >
          <img [lazyLoad]="'assets/icons/trash.svg'" alt="trash" />
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
